import request from '@/utils/request'
export function getList(data) {
  return request({
    url: `/home/art/recom/list`,
    method: "get",
    params: data
  });
}